import { IFeed } from '@interfaces/index';
import { showError } from '@lib/utils';
import { feedService } from '@services/feed.service';
import { Alert, Spin } from 'antd';
import { useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import dynamic from 'next/dynamic';
import ViewMediaPopupContainer from 'src/context/view-media-popup/view-media-popup-container';
import Link from 'next/link';
import { SearchOutlined } from '@ant-design/icons';
import { useRouter } from 'next/router';
import style from './scroll-list.module.scss';

const FeedCard = dynamic(() => import('../card/feed-card'));

interface IProps {
  initPosts: {
    data: IFeed[];
    total: number;
  }
}

function ScrollListHomeFeed({
  initPosts
}: IProps) {
  const [fetching, setFetching] = useState(false);
  const [items, setItems] = useState<IFeed[]>(initPosts.data);
  const [total, setTotal] = useState<number>(initPosts.total);
  const offset = useRef<number>(0);
  const router = useRouter();

  const moreItems = async () => {
    try {
      setFetching(true);
      offset.current += 1;
      const offsetValue = offset.current * 24;
      const resp = await feedService.userSearch({
        ...router.query,
        limit: 24,
        offset: offsetValue,
        isHome: true
      });
      setItems([...items, ...resp.data.data]);
      setTotal(resp.data.total);
    } catch (e) {
      showError(e);
    } finally {
      setFetching(false);
    }
  };

  const getMore = () => {
    moreItems();
  };

  useEffect(() => {
    offset.current = 0;
    setItems(initPosts.data);
    setTotal(initPosts.total);

    // Quick check if page is scrollable
    setTimeout(() => {
      const sh = document.documentElement.scrollHeight;
      const ch = window.innerHeight;
      console.log(`Page height: ${sh}, Viewport: ${ch}, Scrollable: ${sh > ch}`);
    }, 1000);
  }, [JSON.stringify(initPosts)]);

  const hasMoreItems = total > items.length;

  return (
    <InfiniteScroll
      dataLength={items?.length}
      hasMore={hasMoreItems}
      loader={<div className="text-center" style={{ padding: '20px' }}><Spin /></div>}
      next={() => {
        !fetching && getMore();
      }}
      endMessage={<p style={{ textAlign: 'center', marginTop: '20px', paddingBottom: '20px' }}>You've reached the end!</p>}
      scrollThreshold={0.8}
    >
      <ViewMediaPopupContainer>
        <div className={style['fixed-scroll']}>
          {items.map((item: any, index: number) => (
            <FeedCard
              priority={index < 5}
              feed={item}
              key={item._id}
            />
          ))}
        </div>
      </ViewMediaPopupContainer>
      {!items.length && !fetching && (
      <div className="main-container custom text-center" style={{ margin: '10px 0' }}>
        <Alert
          type="warning"
          message={(
            <Link href="/creator">
              <SearchOutlined />
              {' '}
              Find someone to follow
            </Link>
           )}
        />
      </div>
      )}
    </InfiniteScroll>
  );
}

export default ScrollListHomeFeed;
